import { useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This is custom query hook is used to fetch the Courier details from the backend.
 */
export const INBOUND_COURIER_INFO_KEY = 'inbound-courier-info-query';

/**
 * This hook fetches the inbound details.
 */
export const useInboundCourierInfoQuery = (inboundIdentifier: string) => {
  const { data, isError, error, isPending, refetch } = useQueryWithUserId({
    queryKey: [INBOUND_COURIER_INFO_KEY, inboundIdentifier],
    networkMode: 'always',
    queryFn: () => INV_MGMT_SERVICE_API.getCourierInfo(inboundIdentifier),
  });

  return {
    data,
    error,
    isError,
    isPending,
    refetchCourierInfo: refetch,
  };
};
